module.exports = __webpack_public_path__ + "media/images/routes-home-7200e092f97655656c882c860837b5cc.png";